
import React from 'react';
import { Button } from "@/components/ui/button";
import { useSessionStore } from '@/store/sessionStore';
import { RefreshCw } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

interface SessionActionsProps {
    onNewSession: () => void;
    onFollowUp: () => void;
    isLoading: boolean;
    currentSessionId: string | null;
    currentSessionStatus: string;
}

const SessionActions: React.FC<SessionActionsProps> = ({
    onNewSession,
    onFollowUp,
    isLoading,
    currentSessionId,
    currentSessionStatus,
}) => {
    const { loadActiveSession } = useSessionStore();

    return (
        <div className="flex flex-wrap items-center gap-2">
            <Button onClick={onNewSession} variant="outline" className="flex-grow" disabled={isLoading && currentSessionStatus === 'loading' && !currentSessionId}>
                {isLoading && currentSessionStatus === 'loading' && !currentSessionId ? 'Starting...' : 'New Session'}
            </Button>
            <Button onClick={onFollowUp} variant="outline" className="flex-grow" disabled={!currentSessionId || isLoading}>
                Follow-up
            </Button>
            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <Button
                            variant="outline"
                            size="icon"
                            className="flex-shrink-0"
                            onClick={loadActiveSession}
                            disabled={isLoading}
                        >
                            <RefreshCw className={`h-4 w-4 ${isLoading ? 'animate-spin' : ''}`} />
                        </Button>
                    </TooltipTrigger>
                    <TooltipContent>
                        <p>Reload Active Session (Option+R)</p>
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
};

export default SessionActions;